import React from "react";
import { useNavigate } from "react-router";
import { getDatabase, ref, remove } from "firebase/database";
import { deleteObject, getStorage, ref as storageRef } from "firebase/storage";
import { PenSquare, Plus, Trash2 } from "lucide-react";

import { useNotification } from "../../../contexts/NotificationContext";
import { useCatalog } from "../../../contexts/CatalogContext";
import { Button } from "../../../components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../components/ui/table";
import { Item } from "./Item";
import { Title } from "./Title";

export default function Drivers() {
  const navigate = useNavigate();
  const { drivers } = useCatalog();
  const { showNotification } = useNotification();

  const handleDeleteDriver = async (driver: string, key: string) => {
    try {
      const db = getDatabase();
      const driversRef = ref(db, `drivers/${key}`);
      const storage = getStorage();
      const photoRef = storageRef(storage, `drivers/${key}`);
      await remove(driversRef);
      await deleteObject(photoRef);
      showNotification("success", `Motorista ${driver} removido com sucesso.`);
    } catch (error) {
      showNotification(
        "error",
        `Ocorreu um erro ao remover o motorista ${driver}.`
      );
    }
  };

  return (
    <section className="space-y-3">
      <Title>Motoristas</Title>
      <Item className="space-y-4">
        {drivers.length === 0 ? (
          <p className="text-sm text-white/60">
            Nenhum motorista adicionado ainda.
          </p>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Nome</TableHead>
                <TableHead>Telefone</TableHead>
                <TableHead className="text-right">Ações</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {drivers.map(({ id, data }) => (
                <TableRow key={id}>
                  <TableCell className="font-medium">{data.name}</TableCell>
                  <TableCell>{data.phone}</TableCell>
                  <TableCell className="text-right">
                    <div className="flex justify-end gap-2">
                      <Button
                        variant="ghost"
                        size="icon"
                        onClick={() => navigate(`/admin-management/others/drivers/edit/${id}`)}
                      >
                        <PenSquare className="h-4 w-4" />
                      </Button>
                      <Button
                        variant="ghost"
                        size="icon"
                        onClick={() => handleDeleteDriver(data.name, id)}
                        className="text-destructive"
                      >
                        <Trash2 className="h-4 w-4" />
                      </Button>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
        <Button
          variant="outline"
          className="w-full"
          onClick={() => navigate("/admin-management/others/drivers/add")}
        >
          <Plus className="mr-2 h-4 w-4" /> Adicionar motorista
        </Button>
      </Item>
    </section>
  );
}
